module.exports = __webpack_public_path__ + "static/media/aug.a1deda66.jpg";